// components/Common/Shimmer.js
//
// No stylesheet — converted to Tailwind utilities in Phase 5. Shimmer.scss was
// deleted in the same commit (TOKEN_CONTRACT §6.1); its @keyframes moved to
// theme.extend.keyframes in tailwind.config.js, and its [data-theme="dark"] fork
// is gone: --shimmer-base and --shimmer-highlight switch on their own.
//
// tw-mb-4, not tw-mb-3. Bootstrap's mb-3 is 1rem and Tailwind's is 0.75rem, so
// the same class name would have quietly tightened every loading state in the app
// (audit F15 — the reason the tw- prefix exists).
import React from "react";

// The gap separates bars from each other, so the LAST bar must not have one.
// A trailing 1rem is invisible on a full-page skeleton and very visible inside a
// table cell or a button, which is where the single-bar case is now used.
const Shimmer = ({ height = 48, count = 1 }) => (
  <div>
    {Array.from({ length: count }).map((_, i) => (
      <div
        key={i}
        className={`tw-w-full tw-animate-shimmer tw-bg-gradient-to-r tw-from-shimmer tw-via-shimmer-highlight tw-to-shimmer tw-bg-[length:400%_400%]${
          i === count - 1 ? '' : ' tw-mb-4'
        }`}
        style={{ height: height, borderRadius: 8 }}
      />
    ))}
  </div>
);

export default Shimmer;
